var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Существующие объекты по использованию отхода")]),_c('use-registry-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }